export function createApiKeyError() {
    return new Error('API key is missing. Please provide an API key using the `apiKey` option.');
}
createApiKeyError.code = 1;
export function autoPullParamError() {
    return new Error(`autoPull typeof boolean. Please enter boolean value`);
}
autoPullParamError.code = 2;
export function requestAuthError(data) {
    console.error(data.message);
}
requestAuthError.code = 401;
//# sourceMappingURL=error.js.map